// @ts-nocheck
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate, useLocation } from 'react-router-dom'
import { imageConfig } from '../../../../config/config'
import { getText } from '../../../../utils/util'
import { Star, ChevronLeft, ListOrdered } from 'lucide-react'
import './index.css'

export default function TopBar({ coinname, iscollect, collectAdd, collectDel }) {
  const navigate = useNavigate()
  const location = useLocation()
  const { t: translate } = useTranslation()
  
  // 判断当前路径是哪个页面
  const isTradeActive = location.pathname.includes('/trade/')
  const isLeverActive = location.pathname.includes('/lever/')
  
  //杠杆隐藏
  let companyId = localStorage.getItem('companyId')
  console.log('faith=============companyId-9', companyId)
  //先取消隐藏
  const removeCompanyId = -1
  return (
    <div className="flex items-center justify-between p-4">
      <div className="flex items-center">
        <button
          className="mr-3 text-neutral-400 hover:text-white"
          onClick={() => navigate(-1)}
        >
          <ChevronLeft size={24} />
        </button>

        <div className="flex bg-neutral-700 rounded-lg overflow-hidden">
          <button
            className="px-8 py-2 text-sm font-medium transition-colors"
            style={{
              backgroundColor: isTradeActive ? "#8B5CF6" : "transparent",
              color: isTradeActive ? "white" : "#94A3B8",
            }}
            onClick={() => {
              navigate(`/trade/${coinname}`);
            }}
          >
            {translate(getText("期權"))}
          </button>
          {/* {companyId !== '2080395267' && (
            <button
              className="px-4 py-2 text-sm font-medium transition-colors"
              style={{ 
                backgroundColor: isLeverActive ? '#8B5CF6' : 'transparent', 
                color: isLeverActive ? 'white' : '#94A3B8',
                display: companyId != removeCompanyId ? 'block' : 'none'
              }}
              onClick={() => {
                if (companyId != removeCompanyId) {
                  navigate(`/lever/${coinname}`)
                }
              }}
            >
              {translate(getText('杠杆'))}
            </button>
          )} */}
        </div>
      </div>

      <div className="flex items-center">
        <button
          className="flex items-center text-neutral-300 hover:text-white mr-4"
          onClick={() => {
            navigate("/jyjlTrade");
          }}
        >
          <ListOrdered size={18} className="mr-1" />
          <span className="text-sm">{translate(getText("持倉"))}</span>
        </button>

        <button
          className="text-neutral-300 hover:text-white"
          onClick={() => {
            if (iscollect) {
              collectDel();
            } else {
              collectAdd();
            }
          }}
        >
          <Star
            size={20}
            fill={iscollect ? "#F59E0B" : "none"}
            color={iscollect ? "#F59E0B" : "currentColor"}
          />
        </button>
      </div>
    </div>
  );
}
